export const SCREEN_LARGE_DESKTOP = 'largeDesktop';
export const SCREEN_DESKTOP = 'desktop';
export const SCREEN_TABLET = 'tablet';
export const SCREEN_MOBILE = 'mobile';
